import configSelector from "../../external/configSelector";
import Card from "@urbanpiper-engineering/meraki-components/dist/Atoms/Card";
import { getStaticProps as getInitialProps } from "../../hooks/server.props";
import SeoData from "../../components/seo_data";
import styles from "./custom.module.scss";

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export async function getStaticProps(ctx: any) {
  const intialProps = await getInitialProps(ctx);

  const slug = ctx.params.slug;
  const customPages = configSelector.getCustomPages();
  const page = customPages.find((page: any) => page.path.substring(1) === slug);

  const seoData = page?.seo?.[ctx.locale] || {};

  return {
    props: {
      ...intialProps.props,
      page,
      seoData,
    },
  };
}

function CustomPage({ page, seoData }: any) {
  return (
    <div className={styles.custom}>
      <SeoData seoData={seoData} />
      <h1 className="visually-hidden">{seoData?.title || page?.name}</h1>
      <Card>
        <div dangerouslySetInnerHTML={{ __html: page?.content }} />
      </Card>
    </div>
  );
}

export default CustomPage;
